import client from './client';

export interface DashboardStats {
  total_users?: number;
  new_users_week?: number;
  egov_verified?: number;
  active_today?: number;
  total_appeals?: number;
  open_appeals?: number;
  news_published?: number;
  active_shutoffs?: number;
  appeals_by_status?: Record<string, number>;
  recent_appeals?: {
    id: number;
    title: string;
    status: string;
    created_at: string;
    address?: string;
    department?: string;
  }[];
}

export interface AdminUser {
  id: string;
  phone: string | null;
  iin: string | null;
  full_name: string | null;
  email: string | null;
  address: string | null;
  district: string | null;
  language: string;
  role: string;
  is_active: boolean;
  egov_verified: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export interface UsersListResponse {
  items: AdminUser[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export interface UsersStats {
  total: number;
  active: number;
  egov_verified: number;
  new_last_7_days: number;
  by_role: Record<string, number>;
}

export interface UserUpdatePayload {
  role?: string;
  is_active?: boolean;
  full_name?: string;
  district?: string;
}

export const usersApi = {
  getStats: () => client.get<DashboardStats>('/api/admin/analytics/dashboard'),
  list: (params: { search?: string; role?: string; is_active?: boolean; page?: number; size?: number }) =>
    client.get<UsersListResponse>('/api/admin/users', { params }),
  stats: () => client.get<UsersStats>('/api/admin/users/stats'),
  get: (id: string) => client.get<AdminUser>(`/api/admin/users/${id}`),
  update: (id: string, payload: UserUpdatePayload) =>
    client.patch<AdminUser>(`/api/admin/users/${id}`, payload),
  delete: (id: string) => client.delete(`/api/admin/users/${id}`),
};
